import React, { useEffect, useState, useRef } from 'react';
import { DropdownList, DateTimePicker } from 'react-widgets';
import { getAssignedValue, getValues, translateProperty } from '../../../../util';
import { PropTypes } from 'prop-types';
import { ProductLink } from '../../../../components';
import { Box, MenuItem, Select } from '@mui/material';
import classNames from 'classnames';

export const ConfiguratorVariable = ({ variable, onChange, lang, selectedValue, setSelectedValue, className, removable,configurableProduct ,bom  }) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const selectRef = useRef(null); // Create a ref
  const [menuWidth, setMenuWidth] = useState(null);
  const { properties, values, showAs, show} = variable;
  const eventChange = e => onChange( variable, e.target.value );
  const disabled = variable.properties.ReadOnly ;
  const change = value => {setSelectedValue(value.title);onChange( variable, value )};
  const onSelectchange = e => {setSelectedValue(e.target.value.title);onChange( variable, e.target.value )};  
  const isBomItem = properties.IsBomItem === undefined || properties.IsBomItem;
  const itemComponent = item => {
    if(item.item && bom?.any(b=>b.name===item.item.name)){
      return item.item && isBomItem ? <ProductLink { ...item.item} title={<p style ={{color:'green'}}>{item.item.title}</p> } /> : item.item.title
    }
    return item.item && isBomItem ? <ProductLink { ...item.item } /> : item.item.title
  }; 
  const renderValue = (item)=>{console.log(item)}

  const handleOpen = () => {
    setMenuOpen(true);
    if (selectRef.current) {
      setMenuWidth(selectRef.current.offsetWidth); // Get Select width
    }
  };

  const handleClose = () => {
    setMenuOpen(false);
  };
  if (!show) {
    return null;
  }

  const assignedValue = getAssignedValue(variable);

  switch (showAs) {
    case 'Boolean':
      return <input type="checkbox" checked={ assignedValue === true } onChange={ eventChange } />;
    case 'RadioButton':
      return <input type="radio" checked={ assignedValue === true } onChange={ eventChange } />;
    case 'Calculated':
      return <label>{assignedValue}</label>;
    case 'Date':
      return <DateTimePicker value={ assignedValue } onChange={ change } />;
    case 'InputField':
      return <input disabled= { disabled } style={ { width: '100%' } } className="text-input-field rw-input rw-widget-picker rw-widget-container" type="text" value={ assignedValue } onBlur={ eventChange } />;
    case 'TextArea':
      return <textarea rows="3" columns="80" onBlur={ eventChange } style={ { width: '100%' } }>{ assignedValue }</textarea>;
    default:
      return <Select 
        value={variable && variable.assignedValue ? (variable.assignedValue.title === 'NO_DISPLAY' ? '' : variable.assignedValue.title):''} 
        onChange={ onSelectchange } 
        onOpen={handleOpen}
        onClose={handleClose}
        className={classNames("select-element",{"selected":removable,"not-selected":!removable,"menu-open":menuOpen})}
        ref={selectRef}
        sx={{
          '& .MuiOutlinedInput-root': {
            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
              borderColor: 'inherit !important',
              outline: 'none',
              boxShadow: 'none',
            }
          },
        }}
        MenuProps={{classes: {paper: 'select-menu-paper'},
        MenuListProps: {
          className: 'select-ul',
          sx: {
            maxWidth: menuWidth ? `${menuWidth}px` : 'auto',
          }
        },
        sx: {
          '.MuiBackdrop-root': {
            opacity: '0 !important',
            '&.select-backdrop': {
              opacity: '0 !important',
            },
          },
        },
      }}
      >
            {getValues(variable, values, lang,configurableProduct,bom).map(value=><MenuItem disableRipple disableTouchRipple sx={{ '&.Mui-focusVisible': { backgroundColor: 'transparent' },
            '&.Mui-selected': { 
              backgroundColor: 'var(--primary-color-background-tertiary-white, #F5F5F5)', 
              background:'var(--primary-color-background-tertiary-white, #F5F5F5)' },
              '&.Mui-selected:hover': { 
                backgroundColor: 'var(--primary-color-background-tertiary-white, #F5F5F5)', 
                background:'var(--primary-color-background-tertiary-white, #F5F5F5)' },
                '&.Mui-selected.Mui-focusVisible': {
                  backgroundColor: 'var(--primary-color-background-tertiary-white, #F5F5F5)', 
                background:'var(--primary-color-background-tertiary-white, #F5F5F5)' }
              }}  className={classNames("menu-item",{"item-selected":variable && variable.assignedValue && value.title===variable.assignedValue.title})} value={value}>{itemComponent({item:value})}</MenuItem>)}
      </Select>
  }
};

ConfiguratorVariable.propTypes = {
  lang: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  variable: PropTypes.shape({
    assignedValue: PropTypes.shape({})
  })
};